<template>
  <div class="p-4">
    <h6 class="mb-base">Frequently Asked Questions</h6>
    <vs-collapse accordion type="shadow">
      <vs-collapse-item>
        <div slot="header">Morbi turpis justo, varius nec risus in</div>
        {{ helpText }}
      </vs-collapse-item>

      <vs-collapse-item>
        <div slot="header">Quisque at placerat risus, ac pellentesque leo</div>
        {{ helpText }}
      </vs-collapse-item>

      <vs-collapse-item>
        <div slot="header">Etiam fermentum dictum velit, et blandit </div>
        {{ helpText }}
      </vs-collapse-item>

      <vs-collapse-item>
        <div slot="header">Lorem ipsum dolor sit amet, consectetur adipiscing</div>
        {{ helpText }}
      </vs-collapse-item>
    </vs-collapse>
  </div>
</template>

<script>
export default {
  data() {
    return {
      title: "",
      helpText:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.",
    };
  },
};
</script>

<style scoped>
</style>
